export default __webpack_public_path__ + "static/media/Dina2.73b4c630.PNG";